import { ActualPack } from '~/Api/Analytics/VirtualBrand';
import { areProductPricesEqual } from '~/Api/Product';

export default function arePacksEqual(pack: ActualPack, otherPack: ActualPack): boolean {
	const { pricesMap } = pack;
	const { pricesMap: previousPricesMap } = otherPack;

	return (
		otherPack.dataSource.type === pack.dataSource.type &&
		otherPack.companyName === pack.companyName &&
		areProductPricesEqual(pricesMap['ex-factory'] ?? null, previousPricesMap['ex-factory'] ?? null) &&
		areProductPricesEqual(pricesMap['ex-factory-with-vat'] ?? null, previousPricesMap['ex-factory-with-vat'] ?? null) &&
		areProductPricesEqual(pricesMap.wholesale ?? null, previousPricesMap.wholesale ?? null) &&
		areProductPricesEqual(pricesMap['wholesale-with-vat'] ?? null, previousPricesMap['wholesale-with-vat'] ?? null) &&
		areProductPricesEqual(pricesMap.retail ?? null, previousPricesMap.retail ?? null) &&
		areProductPricesEqual(pricesMap['retail-with-vat'] ?? null, previousPricesMap['retail-with-vat'] ?? null)
	);
}
